module.exports = __webpack_public_path__ + "img/medal.0a82a550.png";